import { Link } from 'react-router-dom';
import { ReactComponent as CodenamesIcon } from '../images/codenames.svg';
import { ReactComponent as DecryptoIcon } from '../images/decrypto.svg';
import { ReactComponent as WavelengthIcon } from '../images/wavelength.svg';
import DesiMonikers from '../components/desi-monikers/DesiMonikers';

function Home() {
  const codenameTileStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/codenames.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };
  
  const codenamesDuetTileStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/codenames-duet.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  const decryptoTileStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/decrypto.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  const wavelengthTileStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/wave.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  const indianMonikersTileStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/placeholder.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  };

  return (
    <div className="App">
      <header>
        <h1>Board Games Bond</h1>
        <p className="tagline">Connect with friends over strategic board games</p>
      </header>
      
      <div className="game-tiles">
        <Link 
          to="/codenames"
          className="game-tile" 
          role="button"
          aria-label="Codenames board game"
          style={codenameTileStyle}
        >
          <div className="game-info">
            <div className="icon-wrapper">
              <CodenamesIcon />
            </div>
            <h2>Codenames</h2>
            <p>A word association game of spies and secrets</p>
          </div>
        </Link>
        
        <Link 
          to="/codenames-duet"
          className="game-tile" 
          role="button"
          aria-label="Codenames Duet board game"
          style={codenamesDuetTileStyle}
        >
          <div className="game-info">
            <div className="icon-wrapper">
              <CodenamesIcon />
            </div>
            <h2>Codenames Duet</h2>
            <p>A cooperative word game for two players</p>
          </div>
        </Link>
        
        <Link 
          to="/decrypto"
          className="game-tile" 
          role="button"
          aria-label="Decrypto board game"
          style={decryptoTileStyle}
        >
          <div className="game-info">
            <div className="icon-wrapper">
              <DecryptoIcon />
            </div>
            <h2>Decrypto</h2>
            <p>Code-breaking team communication challenge</p>
          </div>
        </Link>
        
        <Link 
          to="/wavelength"
          className="game-tile" 
          role="button"
          aria-label="Wavelength board game"
          style={wavelengthTileStyle}
        >
          <div className="game-info">
            <div className="icon-wrapper">
              <WavelengthIcon />
            </div>
            <h2>Wavelength</h2>
            <p>A cooperative game about reading minds</p>
          </div>
        </Link>
        
        <Link 
          to="/desi-monikers"
          className="game-tile" 
          role="button"
          aria-label="Desi Monikers card game"
          style={indianMonikersTileStyle}
        >
          <div className="game-info">
            <div className="icon-wrapper">
              <CodenamesIcon />
            </div>
            <h2>Desi Monikers</h2>
            <p>A fun card game with an Indian twist</p>
          </div>
        </Link>
      </div>
      
      <footer>
        <p>Select a game to learn more or start playing!</p>
      </footer>
    </div>
  );
}

export default Home; 